var exports = {
  "kL": "x31de4314--9bc66f--container",
  "Qs": "x31de4314--9bc66f--content",
  "dR": "x31de4314--9bc66f--content--text",
  "Sl": "x31de4314--9bc66f--image",
};

module.exports = exports;
